module.exports = __webpack_public_path__ + "static/media/330px-Toniolo.8708669b.jpg";